import React from "react";

// const timer = document.getElementById('timer');
const timer = $("#timer");
let time = 180000;
let min = 3;
let sec = 60;

let playTime;

// timer.value=min+":"+"00";

export const action_timer = () => {
    fn_timer();

    setTimeout(function() {
        clearInterval(playTime);
    },180000);
}

const fn_timer = () => {
    resetTimer();

    $("#timer").val(min+":"+"00");
    $("input[name='attctNo']").removeAttr('disabled');
    playTime=setInterval(function(){
        time=time-1000; //1초씩 줄어듦
        min=time/(60*1000); //초를 분으로 나눠준다.

       if(sec>0){ //sec=60 에서 1씩 빼서 출력해준다.
            sec=sec-1;
            $("#timer").val(Math.floor(min)+':'+sec); //실수로 계산되기 때문에 소숫점 아래를 버리고 출력해준다.
        }
        if(sec===0){
            // 0에서 -1을 하면 -59가 출력된다.
            // 그래서 0이 되면 바로 sec을 60으로 돌려주고 value에는 0을 출력하도록 해준다.
            sec=60;
            $("#timer").val(Math.floor(min)+':'+'00');
        }     

        if(time == 0) {
            $("#timer").val('인증번호 만료');
            $("input[name='attctNo']").attr('disabled', true);
        }
    },1000); //1초마다 
}

export const fn_delTimer = () => {
    resetTimer();
    $("#time").val('');
}

export const resetTimer = () => {
    time = 180000;
    min = 3;
    sec = 60;
    clearInterval(playTime);
    // setTimeout(function() {
    //     clearInterval(playTime);
    // },180000);
}

export const TimeLimit = (props) => {
    return(
        <input id="timer" type="text" 
            style={{
                width:'36%',
                float:'right',
                textAlign:'center',

                border:'0px',
                backgroundColor:'#fff'
            }}
            readOnly
            disabled
        />
    );
}